module.exports = __webpack_public_path__ + "static/media/gps3.68c42d8a.svg";